import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { Panel, Button, Col, Row, HelpBlock } from 'react-bootstrap';
import { FormActions, Select } from '../../../common/components/formControls';
import CentersDropdownList from '../../centers/DropdownList';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';

const Filter = ({ handleSubmit, reset, loading, pristine, t, months, years, onSubmit }) => {
	const handleReset = () => {
		reset();
		setTimeout(() => handleSubmit());
	};
	return (
		<Panel>
			<Panel.Heading><FontAwesomeIcon icon={faFilter} />{t('Common_Filter')}</Panel.Heading>
			<Panel.Body>
				<form onSubmit={handleSubmit(values => onSubmit({ ...values, isExport: false }))}>
					<Row>
						<Col sm={8}>
							<CentersDropdownList render='field' name='centerId' filter={center => !center.isKindergarten} label={t('RoyaltyReport_Center')} />
						</Col>
						<Col sm={2}>
							<Select name='year' data={years} hideEmptyOption label={t('MonthlyPaymentReport_Year')} />
						</Col>
						<Col sm={2}>
							<Select name='month' data={months} hideEmptyOption label={t('MonthlyPaymentReport_Month')} />
						</Col>
					</Row>
					<FormActions>
						<Button onClick={handleSubmit(values => onSubmit({ ...values, isExport: false }))} disabled={loading} bsStyle='primary'>{t('Common_Filter')}</Button>
						<Button onClick={handleSubmit(values => onSubmit({ ...values, isExport: true }))} disabled={loading} bsStyle='warning'>{t('Common_ExportToExcel')}</Button>
						<Button disabled={pristine || loading} onClick={handleReset}>{t('Common_Reset')}</Button>
					</FormActions>
					<HelpBlock>{t('Common_ExportHelpText')}</HelpBlock>
				</form>
			</Panel.Body>
		</Panel>
	);
};

Filter.propTypes = {
	onSubmit: PropTypes.func.isRequired
};

export default reduxForm({ form: 'centralisedRoyaltyReportFilter' })(withTranslation()(Filter));